import styled from '@emotion/styled';

export type PhotoCountProps = {
    mediaCount: number | undefined;
    mediaIndex: number;
};

const PhotoCountContainer = styled.div`
    flex: 1;
    text-align: center;
    padding-top: var(--rwl-spacing-md);
    vertical-align: middle;
    margin-top: var(--rwl-spacing-sm);
    font-weight: 500;
`;

export function PhotoCount({
    mediaCount,
    mediaIndex,
}: PhotoCountProps): JSX.Element | null {
    if (!mediaCount || mediaCount < 2) {
        return null;
    }
    return (
        <PhotoCountContainer>
            {mediaIndex + 1} / {mediaCount}
        </PhotoCountContainer>
    );
}
